// media/index.js
function importAll(r) {
  let images = {};
  r.keys().forEach((key) => {
    const fileName = key.replace("./", "");       // "logo.svg"
    const [name, ext] = fileName.split(".");      // "logo", "svg"
    const normalizedName = name.replace(/-/g, "_"); // handle hyphens

    // create nested object if not exists
    if (!images[normalizedName]) {
      images[normalizedName] = {};
    }

    images[normalizedName][ext] = r(key); // store by extension
  });
  return images;
}

const media = importAll(require.context("../media", false, /\.(png|jpe?g|svg)$/));

export default media;
